import styled from 'styled-components';

import { background, border } from '../providers/theme/theme.index';

const IconWrapper = styled.div<{ size?: number; backgroundColor?: string; noOutline?: boolean }>`
  width: ${(props) => props.size || 48}px;
  height: ${(props) => props.size || 48}px;
  background-color: ${(props) => props.backgroundColor || background.primary};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: ${(props) => (props.noOutline ? '' : `${border.secondary} solid 1px`)};
  z-index: 1;
  overflow: hidden;
  min-width: 16px;
`;

export default IconWrapper;
